import React, {useEffect, useState} from 'react';
import TimeZone from './TimeZone';
import {Row,Col} from 'react-bootstrap';
import './Body.scss';
import TrafficStatus from './TrafficStatus';
import SharedServices from './SharedServices';
import HealthCheckServices from  './HealthCheckServices' 
import ErrorBoundary from '../ErrorBoundary'
import {useSelector} from 'react-redux'
// const HealthCheck = lazy(() => import('./HealthCheckServices'))

const Body = () => {
    const regions = ['us-east-1','us-west-2']
    const [region, setRegion] = useState(regions);
    const activeRegion  = useSelector((state:any) => state.activeRegion.region)
    
    useEffect(() => {
        console.log('activeRegion',activeRegion)
        if(activeRegion === 'active'){
            setRegion(['us-east-1','us-west-2'])
        }
        else {
          //  setRegion(['us-east-2','us-west-1'])
        }
    },[activeRegion])
    
    return <div className='bodyContainer'>
        <Row className='columnSplit'>
            <Col lg={12} xl={10}>
                <ErrorBoundary>
                    <Row className='healthCheckServices'>
                        {
                            region.map((item,index) => <HealthCheckServices key={index} index={index} region={item} />)
                        }
                    </Row>
                </ErrorBoundary> 
            </Col>
            <Col lg={12} xl={2}>
                <div className='timezoneContainer'>
                <TimeZone/>
                <TrafficStatus/>
               </div>
               <SharedServices/>
            </Col>
        </Row>
    </div>
}

export default Body;